import { render, staticRenderFns } from "./FactoryList.vue?vue&type=template&id=63410760&scoped=true&"
import script from "./FactoryList.vue?vue&type=script&lang=js&"
export * from "./FactoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63410760",
  null
  
)

export default component.exports